$(document).ready(function() {
    const $slideshow = $('.hero-slideshow');

    const slickOptions = {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000
    };
    $slideshow.slick(slickOptions);
});
